import React from 'react';
import { List, Modal, Space } from 'antd';
import { AppstoreAddOutlined } from '@ant-design/icons';
import { getIcon } from '../utils/iconMap';
import Button from "@common/Button";

const BlockLibraryModal = ({ visible, onCancel, instructionalBlocks, onAddBlock }) => {
    return (
        <Modal
            title={<Space><AppstoreAddOutlined />Instructional Block Library</Space>}
            open={visible}
            onCancel={onCancel}
            footer={null}
            width={800}
        >
            <List
                itemLayout="horizontal"
                dataSource={instructionalBlocks}
                renderItem={block => (
                    <List.Item actions={[<Button type="primary" onClick={() => onAddBlock(block)}>Add Block</Button>]}>
                        <List.Item.Meta
                            key={block.key}
                            avatar={React.cloneElement(getIcon(block.icon), {style: {fontSize: 24}})}
                            title={block.title}
                            description={block.description}
                        />
                    </List.Item>
                )}
            />
        </Modal>
    );
};

export default BlockLibraryModal;
